import _ from 'lodash';

import { ITEMS_LIST_VIEW_FILTER_KEY } from './ItemsListFilter';

const getSelectedIDs = options => options.filter(element => element.selected).map(element => element.value);

const extractData = rawFilters => rawFilters
  .map(rawFilter => ({
    name: rawFilter.name,
    values: getSelectedIDs(rawFilter.options),
  }))
  .filter(filter => filter.values.length > 0);

/**
 * Filters list is of format :
 * filtersList = [
 *  {
 *    name: 'FILTER_NAME',
 *    values: [el1, el2, el3],
 *  },
 *  {
 *    name: 'FILTER_NAME_2',
 *    values: [el1, el2, el3],
 *  },
 * ];
 */
export const buildFilterationQueryInputInternal = filtersList => ({
  path: '^.input',
  update: {
    filter: filtersList,
  },
});

export const buildFiltrationQueryInputRaw = (rawFiltersList) => {
  const filtersList = extractData(rawFiltersList);
  return buildFilterationQueryInputInternal(filtersList);
};

export const buildFiltrationQueryInput = compactFilters => buildFilterationQueryInputInternal(
  _.toPairs(compactFilters).map(([name, values]) => ({
    name,
    values,
  })),
);

class FiltersUpdaterWrapper {
  constructor(updateFiltersVariables) {
    this.updateFiltersVariables = updateFiltersVariables;
  }

  refetch = (filters) => {
    this.updateFiltersVariables(ITEMS_LIST_VIEW_FILTER_KEY, [
      buildFiltrationQueryInputRaw(filters),
    ]);
  };
}

export default FiltersUpdaterWrapper;
